import { PATH } from '@/constants/path';
// import { dataSettingsSelector } from '@/redux/slice/dataSettings.slice';
import { Button, ButtonGroup, Frame, Link, Page, PageProps } from '@shopify/polaris';
import { HomeIcon } from '@shopify/polaris-icons';
import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import RegularText from '../RegularText';
import SkeletonPage from '../SkeletonPage';
import Toast from '../Toast/Toast';
import { LayoutStyled } from './styled';

interface ILayoutProps extends PageProps {
  headers?: React.ReactNode;
  isBigHeader?: boolean;
  isFullWidth?: boolean;
}

const Layout = ({ ...props }: ILayoutProps): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const isLoading = false;

  const btnGroup = [
    {
      content: t('dashboard'),
      icon: HomeIcon,
      path: PATH.DEFAULT,
    },
    {
      content: t('store_verification'),
      icon: HomeIcon,
      path: PATH.POP_UP_CUSTOMIZATION,
    },
    // {
    //   content: t('checkout_verification'),
    //   icon: HomeIcon,
    //   path: PATH.CHECKOUT_VERIFICATION,
    // },
    // {
    //   content: t('terms_conditions'),
    //   icon: HomeIcon,
    //   path: PATH.TERM_AND_CONDITION,
    // },
    // {
    //   content: t('translation'),
    //   icon: LanguageTranslateIcon,
    //   path: PATH.TRANSLATION,
    // },
    {
      content: t('setting'),
      icon: HomeIcon,
      path: PATH.SETTINGS,
    },
    {
      content: t('pricing'),
      icon: HomeIcon,
      path: PATH.PRICING_PLAN,
    },
  ];

  const isInIframe = window.self !== window.top;
  const isShowListBtn = !isInIframe;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <LayoutStyled isBigHeader={props.isBigHeader} isFullWidth={props.isFullWidth}>
      <Frame>
        <Toast />
        {isShowListBtn ? (
          <div className="nav-bar">
            <ButtonGroup fullWidth gap="extraTight">
              {btnGroup.map((item, index) => {
                return (
                  <Button
                    key={index}
                    icon={item.icon}
                    variant={
                      location.pathname === item?.path?.pathname || (index === 0 && location.pathname === '/')
                        ? 'primary'
                        : undefined
                    }
                    onClick={() => {
                      navigate({
                        ...item.path,
                      });
                    }}
                  >
                    {item.content}
                  </Button>
                );
              })}
            </ButtonGroup>
          </div>
        ) : null}

        {props.headers || null}
        <Page {...props}>
          {isLoading ? (
            <SkeletonPage />
          ) : (
            <div>
              <div>{props.children}</div>
              <RegularText>
                <div className="layout-footer">
                  {t('please_view')}&nbsp;{' '}
                  <Link removeUnderline external url="https://blockifyapp.com/knowledge-base/blockify-age-verification/">
                    {t('our_document_guideline')}
                  </Link>
                </div>
              </RegularText>
            </div>
          )}
        </Page>
      </Frame>
    </LayoutStyled>
  );
};
export default memo(Layout);
